<template>
  <div>
    <div v-if="type == 'facilities'">
      <div class="title">
        <span >设备简介</span>
      </div>
      <h1 class="h1">{{ data.name }}</h1>
      <h3 style="text-align: center;" v-if="data.englishName">{{ data.englishName }}</h3>
      <p>
        <img :src="data.image"  alt="" style="width: 1000px; display: block; margin: 0 auto;">
      </p>
    </div>
    <div v-else>
      <div class="title">
        <span >{{ data.typeName }}</span>
      </div>
      <h1 class="h1">{{ data.title }}</h1>
      <div class="time">时间: {{ formatTimeStamp(data.createdTime*1000) }}</div>
      <div class="ql-editor" v-html="vHtml"></div>
    </div>
  </div>
</template>

<script>
import {getArticleDetail} from '@/api/api'
import '@/dist/quill.core.css'
import '@/dist/quill.snow.css'
import '@/dist/quill.bubble.css'
export default {
  data () {
    return {
      type: '',
      data: {},
      vHtml: ''
    }
  },
  created () {
    // 这里可以拿到上个页面的请求对象
    const query = this.$route.query
    console.log(query)
    this.query = query
    // 这里发请求拉富文本
    // todo...
    if (!query.type) {
      this.data = JSON.parse(sessionStorage.detail)
      this.type = ''
      this.freshImg(this.data.content)
    }
    if (query.type === 'facilities') {
      this.type = 'facilities'
      this.data = JSON.parse(sessionStorage.detail)
      // alert('1')
    }
    if (query.type === 'query') {
      this.type = 'query'
      getArticleDetail({id: query.id}).then(res => {
        this.data = res.data
        this.vHtml = this.data.content
        this.freshImg(this.data.content)
      })
      // alert('1')
    }
  },
  beforeDestroy () {
    this.data = {}
    this.vHtml = ''
    sessionStorage.detail = ''
  },
  methods: {
    freshImg (text) {
      const regex = new RegExp('<img', 'gi')
      this.data.content = text.replace(regex, `<img style="max-width: 100%; height: 100%"`)
      this.vHtml = this.data.content
    },
    formatTimeStamp (timeStamp) {
      let date = new Date(timeStamp)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hour = date.getHours()
      let minute = date.getMinutes()
      let second = date.getSeconds()

      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      hour = hour < 10 ? '0' + hour : hour
      minute = minute < 10 ? '0' + minute : minute
      second = second < 10 ? '0' + second : second

      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    }
  }
}
</script>

    <style scoped>

.title {
  letter-spacing: 1px;
  font-size: 28px;
  line-height:2em;
  color: #2f4f4f;
  border-bottom: 3px solid #2f4f4f;
  font-weight: bold;
}
.serch {
  margin-top: 20px;
}
.h1{
  text-align: center;
}
.time{
  text-align: center;
  color: #999;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/view/detail.vue